import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export default styled.textarea`
  width: 100%;
  min-height: 155px;
  margin: 0;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  border-color: #d4d7de;
  box-shadow: none;
  display: block;
  padding: 14px;
  outline: none;
  resize: vertical;
  font-size: 16px;
  ${media.md`
    font-size: 14px;
  `}
`;
